import { Outlet, useMatch } from 'react-router-dom';
import { Box } from '@mui/material';

import LayoutContainer from 'components/LayoutContainer';
import { glowColor } from 'theme/colors';

import HeroContent from './HeroContent';
import NavBar from './NavBar';

const NavBarWithContent: React.FC = () => {
  const isRootPath = !!useMatch('/');

  return (
    <LayoutContainer>
      <NavBar />
      {isRootPath && (
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            // Bleed past LayoutContainer's own padding so the glow can extend to the true
            // viewport edge instead of hard-clipping at the padded content column.
            mx: { xs: -1.5, md: -4.5, lg: -19.5, xl: -25.5 },
            px: { xs: 1.5, md: 4.5, lg: 19.5, xl: 25.5 },
          }}
        >
          <Box
            aria-hidden='true'
            sx={{
              position: 'absolute',
              top: '-10%',
              right: '-10%',
              width: '60%',
              height: '70%',
              background: `radial-gradient(ellipse, ${glowColor}, transparent 60%)`,
              pointerEvents: 'none',
            }}
          />
          <HeroContent />
        </Box>
      )}
      <Box component='main' sx={{ pt: isRootPath ? 0 : { xs: 5, md: 7 } }}>
        <Outlet />
      </Box>
    </LayoutContainer>
  );
};

export default NavBarWithContent;
